import { Component, OnInit } from '@angular/core';
import {UsuarioService} from "../../../services/usuario-service";
import {ItemPessoa} from "../../../../cadastro/models/item-pessoa";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import {ItemUsuario, ListaUsuario} from "../../../models/lista-usuario";
import {TipoUsuarioEnum} from "../../../enums/tipo-usuario.enum";
import {Token} from "../../../models/token";
import {AuthService} from "../../../services/auth-service";
import {PlanoService} from "../../../../cadastro/services/plano.service";

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrl: './index.component.css',
    standalone: false
})
export class IndexComponent implements OnInit {
  loading = true;
  token: Token | undefined;
  botaoEditar = false;
  aceitaUsuarios = false;
  public colunas = [`Id`, `Nome`, 'Email', 'Tipo', 'Ativo'];
  public linhas: any[] = [];
  listaUsuarios = new ListaUsuario();

  constructor(private usuarioService: UsuarioService,
              private toastr: ToastrService,
              private tokenService: AuthService,
              private planoService: PlanoService,
              private datePipe: DatePipe) {
    this.buscarUsuarios();
    this.token = this.tokenService.AccessToken;
    if(this.tokenService.AccessToken?.seguranca == 'Admin')
      this.botaoEditar = true;
  }

  ngOnInit(): void {
    this.checarSeAceitaUsuarios();
  }

  private checarSeAceitaUsuarios(){
    this.planoService.checarSeAceitaUsuarios().subscribe(response => {
      if(response.sucesso){
        this.aceitaUsuarios = response.dados;
      }
    });
  }

  private buscarUsuarios(){
    this.usuarioService.selecionarLista().subscribe(response => {
      if(response.sucesso){
        this.listaUsuarios = response.dados;
        this.preencherLista(response.dados.itens);
        this.loading = false;
      }
    }, error =>{
      if(error.status === 404){
        this.toastr.warning("Lista de clientes vazia");
      }
      else{
        this.toastr.error("Erro ao buscar a listagem - HTTP " + error.status );
      }
      this.loading = false;
    });
  }

  private preencherLista(listaItens: ItemUsuario[]){
    for(let item of listaItens) {
      let stringArray: string[] = [];
      let status = '';
      let tipo = '';

      if(item.ativo)
        status = 'Ativo';
      else
        status = 'Desativado';

      switch (item.tipo)
      {
        case TipoUsuarioEnum.admin:
          tipo = 'Administrador';
          break;
        case TipoUsuarioEnum.advogadoGestor:
          tipo = 'Advogado Gestor';
          break;
        case TipoUsuarioEnum.assistenteJuridico:
          tipo = 'Assistente Jurídico';
          break;
        case TipoUsuarioEnum.cliente:
          tipo = 'Cliente';
          break;
        case TipoUsuarioEnum.gestorAdmin:
          tipo = 'Gestor Administrador';
          break;
      }



      stringArray.push(item.id.toString(), item.nome, item.email, tipo, status);
      this.linhas.push(stringArray);
    }
  }
}
